import axios from "axios";
const API = axios.create({ baseURL: "https://api.scoriva.net/api" });

export const orderApi = {
  create: (payload) => API.post("/orders", payload),
};
